module.exports = __webpack_public_path__ + "img/Documents.b3c4f44b.svg";